import type { JobComponent } from "@repo/design-system/lib/client-registry";
import { createSubtemplate } from "@repo/design-system/lib/client-registry";
import type { SectionKey } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import SectionBarHungary from "~/components/job-page/sectionbar/sectionbar-eon-hungary";
import ApplicationProcessEonHungary from "~/components/job-page/subclients/hungary/application-process-eon-hungary";
import BenefitsEonHungary from "~/components/job-page/subclients/hungary/benefits-eon-hungary";
import CompanyEonHungary from "~/components/job-page/subclients/hungary/company-eon-hungary";
import ExperienceReportsEonHungary from "~/components/job-page/subclients/hungary/experience-reports-eon-hungary";
import HeaderImageEonHungary from "~/components/job-page/subclients/hungary/headerimage-eon-hungary";
import JobAdTemplateEonHungary from "~/components/job-page/subclients/hungary/jobad-template-eon-hungary";

export const sharedOverrides = {
  sectionBar: SectionBarHungary as JobComponent,
  headerImage: HeaderImageEonHungary as JobComponent,
  jobDescription: JobAdTemplateEonHungary as JobComponent,
  applicationProcess: ApplicationProcessEonHungary as JobComponent,
  companyInfo: CompanyEonHungary as JobComponent,
  benefits: BenefitsEonHungary as JobComponent,
  experienceReports: ExperienceReportsEonHungary as JobComponent,
};

export const sharedSections: SectionKey[] = [
  "headerImage",
  "sectionBar",
  "breadcrumb",
  "jobDescription",
  "experienceReports",
  "applicationProcess",
  "companyInfo",
  "benefits",
  "stickyApplyBar",
  "printView",
];

export const fullSectionBarItems = [
  { href: "#job", label: "hungary_sectionBar_job", section: "job" },
  {
    href: "#experienceReports",
    label: "hungary_sectionBar_expReports",
    section: "experienceReports",
  },
  {
    href: "#applicationProcess",
    label: "hungary_sectionBar_applicationProcess",
    section: "applicationProcess",
  },
  { href: "#company", label: "hungary_sectionBar_company", section: "company" },
  {
    href: "#benefits",
    label: "hungary_sectionBar_benefits",
    section: "benefits",
  },
];

// Catch-all for all Hungary jobs that don't match a specific template — must be last in the subtemplates array
export const hungaryDefault = createSubtemplate<SectionKey>({
  name: "default",
  trigger: (job) => job.data.subClients?.includes("hungary") ?? false,
  showProd: true,
  config: {
    overrides: sharedOverrides,
    sections: sharedSections,
    sectionBarItems: fullSectionBarItems,
  },
});
